'use client';

import HoverPrefetchLink from '@/components/hover-prefetch-link';
import { Carousel, CarouselContent, CarouselItem } from '@/components/ui/carousel';
import { cn } from '@/lib/utils';
import Autoplay from 'embla-carousel-autoplay';
import { useEffect, useState } from 'react';

const TopCarousel = ({ banners }) => {
  const [api, setApi] = useState();
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    if (!api) {
      return;
    }

    api.on('select', () => {
      setActiveIndex(api.selectedScrollSnap());
    });
  }, [api]);

  const handleIndicatorClick = index => {
    if (api) {
      api.scrollTo(index);
    }
  };

  return (
    <Carousel
      className='w-full'
      plugins={[
        Autoplay({
          delay: 5000,
        }),
      ]}
      opts={{
        loop: true,
      }}
      setApi={setApi}
    >
      <CarouselContent className='-ml-0 w-full'>
        {banners?.map((item, index) => (
          <CarouselItem
            key={item.id}
            className='w-full pl-0'
          >
            <HoverPrefetchLink
              href={item.link}
              className='w-full'
            >
              <picture>
                <source
                  media='(max-width: 959px)'
                  srcSet={item.m_pic}
                  width={640}
                  height={800}
                />
                <source
                  media='(min-width: 960px)'
                  srcSet={item.p_pic}
                  width={1920}
                  height={790}
                />
                <img
                  alt={item.title}
                  fetchPriority={index === 0 ? 'high' : 'auto'}
                  loading={index === 0 ? 'eager' : 'lazy'}
                  className='h-auto w-full'
                />
              </picture>
            </HoverPrefetchLink>
          </CarouselItem>
        ))}
      </CarouselContent>

      <div className='absolute bottom-2 flex w-full items-center justify-center'>
        {Array.from(
          {
            length: banners.length,
          },
          (_, index) => (
            <div
              key={index}
              className={cn(
                'text-0 mx-1.5 inline-block h-[3px] w-10 cursor-pointer rounded-none bg-white text-center opacity-20',
                {
                  'opacity-100': index === activeIndex,
                },
              )}
              onClick={() => handleIndicatorClick(index)}
            />
          ),
        )}
      </div>
    </Carousel>
  );
};

export default TopCarousel;
